var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailsAlaram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2819 21V16H13.282V21H11.2819ZM19.3575 18.475L15.8072 14.95L17.2323 13.525L20.7576 17.075L19.3575 18.475ZM5.2064 18.475L3.80629 17.075L7.33156 13.525L8.75668 14.95L5.2064 18.475ZM5.28141 6H19.2825V5H5.28141V6ZM8.68167 9H15.8822L16.1823 8H8.38165L8.68167 9ZM8.68167 11C8.2483 11 7.85661 10.871 7.50658 10.613C7.15655 10.3543 6.91487 10.0167 6.78152 9.6L6.28148 8H5.28141C4.73136 8 4.26033 7.804 3.8683 7.412C3.47693 7.02067 3.28125 6.55 3.28125 6V3H21.2826V6C21.2826 6.55 21.087 7.02067 20.6956 7.412C20.3036 7.804 19.8325 8 19.2825 8H18.2824L17.6324 9.7C17.4824 10.0833 17.2407 10.3957 16.9073 10.637C16.5739 10.879 16.1989 11 15.7822 11H8.68167Z",
    fill: "#9C4900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsAlaram);
export default __webpack_public_path__ + "static/media/Details_Alaram.d43cf85205ab4836931156990567718d.svg";
export { ForwardRef as ReactComponent };